var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 50,
    viewBox: "0 0 99 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 36.2501H41C40.3096 36.2501 39.75 35.6905 39.75 35.0001V23.7501H36L48.9091 12.0145C49.3859 11.5811 50.1141 11.5811 50.5909 12.0145L63.5 23.7501H59.75V35.0001C59.75 35.6905 59.1904 36.2501 58.5 36.2501ZM42.25 33.7501H57.25V21.447L49.75 14.6288L42.25 21.447V33.7501Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.036adc3c22c498424f49a3bf03bd73f4.svg";
export { ForwardRef as ReactComponent };